module.exports = __webpack_public_path__ + "img/803c9ed.webp";